import { Helmet } from "react-helmet-async";

const SITE = "UNSTUCK by Tammi";
const BASE_URL = "https://www.unstuckbytammi.com";

/**
 * Per-page SEO. Titles/descriptions carry the store's real keywords
 * (senior activity cards, assisted living activities, inclusive activities).
 * Private routes pass noindex so they never appear in search results.
 */
const Seo = ({ title, description, path = "", noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | 15-Minute Activity Decks & Senior Games`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <link rel="canonical" href={`${BASE_URL}${path}`} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {!noindex && <meta property="og:url" content={`${BASE_URL}${path}`} />}
    </Helmet>
  );
};

export default Seo;
